import React from 'react';
import {Box, useTheme} from '@mui/material';
import Typography from '@mui/material/Typography';
import type {ThesaurusNode} from 'services/thesaurus/types';
import {useThesaurusEditStateContext} from '../contexts';

type Props = {
  node: ThesaurusNode;
};

export const ThesaurusNodeDetailsTitle: React.FC<Props> = ({node}) => {
  const {colors} = useTheme();
  const {getDisplayCode} = useThesaurusEditStateContext();

  const code = getDisplayCode(node);

  return (
    <Box className={'labelBox thesaurusInfoBox'}>
      {code ? (
        <Box className={'outerBox'}>
          <Typography className={'nodeCode'} variant="subtitle1">
            {code}
          </Typography>
        </Box>
      ) : null}
      <Typography
        variant="h3"
        color={colors.burgundy}
        sx={{
          fontSize: '1.2em',
        }}>
        {node.label}
      </Typography>
    </Box>
  );
};
